import { useState } from "react";
import { faqItems } from "@/mocks/homeData";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 text-xs font-medium text-accent-700 uppercase tracking-wider">
              <i className="ri-question-answer-line"></i>
              FAQ
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              常见问答
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              把大家最常问的几个问题集中在这里，答案都围绕「怎么判断、怎么自查」展开，
              不涉及任何播放或账号相关操作。
            </p>
            <div className="mt-6 hidden lg:block rounded-lg bg-background-50 border border-background-200/80 p-5">
              <p className="font-heading text-sm font-semibold text-foreground-950">找不到答案？</p>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                可以回到上面的「8 步排查流程」，按从地址到网络的顺序一条条对照，
                大多数情况都能找到方向。
              </p>
              <a
                href="#steps"
                className="mt-4 inline-flex items-center gap-2 whitespace-nowrap text-sm text-primary-700 hover:text-primary-600 cursor-pointer"
              >
                前往排查流程
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ul className="space-y-3">
              {faqItems.map((item, i) => {
                const isOpen = open === i;
                return (
                  <li key={item.q} className="rounded-lg bg-background-50 border border-background-200/80 overflow-hidden">
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpen(isOpen ? null : i)}
                        aria-expanded={isOpen}
                        className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-4 md:py-5 cursor-pointer"
                      >
                        <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                          {item.q}
                        </span>
                        <span
                          className={`w-7 h-7 rounded-full flex items-center justify-center text-sm shrink-0 transition-colors ${
                            isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                          }`}
                        >
                          <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                        </span>
                      </button>
                    </h3>
                    <div
                      className={`grid transition-all duration-300 ${
                        isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-5 md:px-6 pb-5 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}